export default {
  namespaced: true,
  actions: {
    index ({ rootState }, { config, ...params }) {
      return rootState.axios.get('/jyb/v1frontend/consumable-price/index', {
        ...config,
        params,
      })
    },
  },
}
